export const GET_ALL_TYPES = "GET_ALL_TYPES";
export const RESET_DATA = "RESET_DATA";
export const START_LOADING_TYPES = "START_LOADING_TYPES";
export const STOP_LOADING_TYPES = "STOP_LOADING_TYPES";
export const ERROR_LOADING_TYPES = "ERROR_LOADING_TYPES";